<layout-container>
  <div class="welcome-screen-headers flex flex-col flex-start-center gap-36">
    <h1 data-test-id="welcome-screen-main-header">Welcome to my7N!</h1>
    <h4 data-test-id="welcome-screen-sub-header">
      Here you can create your CV. Remember that the more effort you put into your CV preparation the better job
      conditions we are likely to negotiate for you.
    </h4>
  </div>
  <div class="welcome-content-video-container">
    <mat-card appearance="outlined" class="welcome-content">
      <div
        [ngStyle]="{ height: videoPlayerConfig.containerHeight + 'px' }"
        #welcomeContentVideo
        class="welcome-content-video"
      >
        @if (!showVideo) {
          <div class="welcome-content-video-plug"
               data-test-id="welcome-video-plug"></div>
        }
        @if (!watchedVideo && !showVideo) {
          <button (click)="show()"
                  class="introduction-button"
                  color="primary"
                  data-test-id="welcome-introduction-button"
                  mat-stroked-button>
            Watch introduction
          </button>
        }
        @if (watchedVideo && !showVideo) {
          <button (click)="letMeIn()"
                  class="create-cv-button"
                  color="primary"
                  data-test-id="welcome-create-cv-button"
                  mat-flat-button>Let’s start</button>
        }
        @if (showVideo) {
          <my7n-video-player
            [config]="videoPlayerConfig"
            [module]="LogVideoModules.Welcome"
            (videoEvent)="onVideoPlayerEvent($event)"
            articleId="my7n-welcome-video"
            title="my7N Welcome Video"
            videoUrl="https://player.vimeo.com/video/400226605"
            data-test-id="welcome-video-player"
          ></my7n-video-player>
        }
      </div>
    </mat-card>
  </div>
  <div class="welcome-screen-actions flex flex-center-center">
    <button
      [disableRipple]="true"
      (click)="letMeIn()"
      class="button-hidden-icon"
      color="primary"
      isIconButton="true"
      data-test-id="welcome-skip-btn"
      mat-button
    >
      Skip introduction and start
      <mat-icon svgIcon="arrow_right"></mat-icon>
    </button>
  </div>
</layout-container>
